import React, { useContext, useState } from 'react';
import Picture from './Picture/Picture';
import RadiologyDialog from './Dialogs/RadiologyDialog';
import { EditIcon, TrashIcon } from '../UI/Images/Icons';
// import { TextEditor } from '../UI';
import { getTime, getFullDate } from '../../utils/dateTimeUtil';
import MessagesContext from '../../contexts/messagesContext';
import { styles } from './RadiologyDetail.style';
import { useSelector } from 'react-redux';
import useCheckMobileScreen from '../../hooks/useWidth';
import { useHistory, useParams } from 'react-router';
import WithPatientFileHeader from '../PatientFileHeader/WithPatientFileHeader';
import useCheckAccess from '../../hooks/useCheckAccess';

const RadiologyDetail = () => {
    const isMobile = useCheckMobileScreen();
    const params = useParams();
    const url = `/${params.clinicId}/patient/${params.id}/radiology`;
    const history = useHistory();
    const { messages } = useContext(MessagesContext);
    const { notEditClinical } = useCheckAccess();
    const classes = styles();
    const form = useSelector((state) => state.reports?.form);
    const reportId = useSelector((state) => state.reports?.form?.reportId);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMode, setDialogMode] = useState('');
    const openDialog = (mode) => {
        setDialogMode(mode);
        setDialogOpen(true);
    };
    const handleClose = () => {
        if (isMobile) {
            history.replace(url);
        }
        setDialogOpen(false);
    };
    const handleEdit = () => {
        if (!notEditClinical) {
            if (isMobile) {
                history.push(`${url}/form`);
            } else {
                openDialog('edit');
            }
        }
    };
    const getDateAndTime = () => (
        <div className={classes.info__date}>
            <div>{getFullDate(form.reported)}</div>
            {getTime(form.reported) !== '00:00' && <div>{getTime(form.reported)}</div>}
        </div>
    );
    return (
        <div className={classes.info__container}>
            <>
                {reportId ? (
                    <>
                        <div className={classes.mainInfoContainer}>
                            <div className={classes.info__type} data-testid="type">
                                {form?.type?.name}
                            </div>

                            {!isMobile && getDateAndTime()}

                            <div className={classes.actionButtonsContainer}>
                                <div onClick={handleEdit} data-testid="editIcon">
                                    <EditIcon
                                        width="20px"
                                        height="20px"
                                        disabled={notEditClinical}
                                    />
                                </div>
                                <div
                                    className={classes.info__trash__button}
                                    onClick={() => !notEditClinical && openDialog('delete')}
                                    data-testid="deleteIcon"
                                >
                                    <TrashIcon
                                        width="20px"
                                        height="20px"
                                        disabled={notEditClinical}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className={classes.row}>
                            <div className={classes.info__locations}>
                                {form.location_names?.map((location, index) => (
                                    <div
                                        key={index}
                                        className={classes.info__location}
                                        data-testid="location"
                                    >
                                        {location}
                                    </div>
                                ))}
                            </div>
                            {isMobile && getDateAndTime()}
                        </div>
                        <div>
                            <span>{JSON.parse(form.content).blocks[0].text}</span>
                            {/* <TextEditor
                                controllers={[]}
                                disableEditing={true}
                                defaultValue={form.content}
                                inlineToolbarAvailable={false}
                                handleChange={() => {}}
                            /> */}
                        </div>
                        <div>
                            <Picture
                                showMode={true}
                                reportId={reportId}
                                name="images"
                                imagesFiles={form.images}
                                isRadiology
                            />
                        </div>
                        {!notEditClinical && (
                            <RadiologyDialog
                                dialogMode={dialogMode}
                                openDialog={dialogOpen}
                                handleClose={handleClose}
                            />
                        )}
                    </>
                ) : (
                    <div className={classes.no__report__added}>{messages.noReportSelected}</div>
                )}
            </>
        </div>
    );
};

export default WithPatientFileHeader(RadiologyDetail, ['sidebar', 'radiology'], true, 'white');
